import jwtbutler from 'jwtbutler';

// reveal password
document.addEventListener('click', (e) => {
    if (e.target.closest('.password-reveal-button--login')) {
        e.preventDefault();
        const el = document.querySelector('.login-form__label--password');
        if (el.getAttribute('type') == 'password') {
            el.setAttribute('type', 'text');
            document.querySelector('.password-reveal-button__image-hide').style.display = 'block';
            document.querySelector('.password-reveal-button__image-reveal').style.display = 'none';
        } else {
            el.setAttribute('type', 'password');
            document.querySelector('.password-reveal-button__image-hide').style.display = 'none';
            document.querySelector('.password-reveal-button__image-reveal').style.display = 'block';
        }
    }
});
// input blur
window.loginInputBlur = (el) => {
    el.closest('.field-text').classList.remove('field-text--has-focus');
};
// input focus
window.loginInputFocus = (el) => {
    el.closest('.field-text').classList.add('field-text--has-focus');
};
// input change
window.loginInputChange = (el) => {
    if (el.value.length > 0) {
        el.closest('.field-text').classList.add('field-text--has-content');
    } else {
        el.closest('.field-text').classList.remove('field-text--has-content');
    }
};
// trigger change on chrome autocomplete
window.addEventListener('load', () => {
    setTimeout(() => {
        if (document.querySelector('input:-webkit-autofill') !== null) {
            document.querySelectorAll('input:-webkit-autofill').forEach((el) => {
                el.closest('.field-text').classList.add('field-text--has-content');
            });
        }
    }, 1000);
});

export default new jwtbutler({
    auth_server: process.env.VUE_APP_API_AUTH_URL,
    sso: [process.env.VUE_APP_URL, process.env.VUE_APP_TECBOARD_URL],
    login_form: `<div class="login-form">
        <img src="/files/static/ui/misc/logo.svg" alt="" class="login-form__logo" />
        <form class="login-form__form">
            <div class="field-text field-wrap">
                <label class="field-text__label" for="login-form__label--email">E-Mail-Adresse / Benutzername</label>
                <input type="text" id="login-form__label--email" class="field-text__input" name="email" onfocus="loginInputFocus(this)" onblur="loginInputBlur(this)" onchange="loginInputChange(this)">
            </div>
            <div class="field-text field-wrap">
                <label class="field-text__label" for="login-form__label--password">Passwort</label>
                <input type="password" name="password" class="field-text__input login-form__label--password" id="login-form__label--password" onfocus="loginInputFocus(this)" onblur="loginInputBlur(this)" onchange="loginInputChange(this)">
                <a href="#" title="Password anzeigen/verbergen" class="password-reveal-button password-reveal-button--login">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20.05 12.45" class="password-reveal-button__image-reveal">
                        <defs><linearGradient id="a--inject-1" x1="4.73" y1="0.93" x2="15.32" y2="11.52" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#999"></stop><stop offset="0.2" stop-color="#939393"></stop><stop offset="0.48" stop-color="gray"></stop><stop offset="0.8" stop-color="#636363"></stop><stop offset="1" stop-color="#4d4d4d"></stop></linearGradient><linearGradient id="b--inject-1" x1="8.94" y1="5.16" x2="11.06" y2="7.28" xlink:href="#a--inject-1"></linearGradient></defs>
                        <path d="M10.05,0H10C4.48,0,0,5.54,0,6.22s4.48,6.23,10,6.23h.05c5.52,0,10-5.54,10-6.23S15.57,0,10.05,0ZM10,11a4.78,4.78,0,1,1,4.77-4.78A4.77,4.77,0,0,1,10,11Z" style="fill:url(#a--inject-1)"></path>
                        <circle cx="10" cy="6.22" r="1.5" style="fill:url(#b--inject-1)"></circle>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20.05 18" class="password-reveal-button__image-hide" style="display: none;">
                        <defs><linearGradient id="a--inject-4" x1="8.96" y1="7.94" x2="11.08" y2="10.06" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#999"></stop><stop offset="0.2" stop-color="#939393"></stop><stop offset="0.48" stop-color="gray"></stop><stop offset="0.8" stop-color="#636363"></stop><stop offset="1" stop-color="#4d4d4d"></stop></linearGradient><linearGradient id="b--inject-4" x1="4.72" y1="3.72" x2="15.31" y2="14.31" xlink:href="#a--inject-4"></linearGradient></defs>
                        <circle cx="10.02" cy="9" r="1.5" style="fill:url(#a--inject-4)"></circle>
                        <path d="M15.76,4.65l3-2.94A1,1,0,1,0,17.29.29L13.94,3.65a9.62,9.62,0,0,0-3.89-.87H10C4.48,2.78,0,8.31,0,9c0,.42,1.68,2.66,4.26,4.33l-3,3a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l3.37-3.38a9.58,9.58,0,0,0,3.92.89h.05c5.52,0,10-5.53,10-6.22C20.05,8.58,18.35,6.32,15.76,4.65ZM5.23,9A4.76,4.76,0,0,1,10,4.23,4.69,4.69,0,0,1,12.59,5L6,11.59A4.69,4.69,0,0,1,5.23,9ZM10,13.77A4.69,4.69,0,0,1,7.41,13L14,6.41A4.69,4.69,0,0,1,14.77,9,4.76,4.76,0,0,1,10,13.77Z" style="fill:url(#b--inject-4)"></path>
                    </svg>
                </a>
            </div>
            <button type="submit" class="login-form__submit button button--icon-key">Anmelden</button>
            <div class="field-text field-wrap login-form__sublinks">
                <a href="https://www.tecworld.com/de/impressum/" target="_blank" class="login-form__sublink">Impressum</a> <span class="login-form__sublinks-pipe">|</span> <a href="https://www.tecworld.com/de/datenschutz/" target="_blank" class="login-form__sublink">Datenschutzerklärung</a>
            </div>
        </form>
    </div>`
});
